import classnames from 'classnames';
import React from 'react';
import { Handles, Rail, Slider, Tracks } from 'react-compound-slider';

import { RangeSliderHandle } from './RangeSliderHandle';
import { SliderRail } from './RangeSliderRail';
import { RangeSliderTrack } from './RangeSliderTrack';

interface RangeSliderProps {
  dataTestId?: string;
  disabled?: boolean;
  disabledMessage?: string;
  domain: number[];
  onChange: (values: ReadonlyArray<number>) => void;
  onUpdate: (values: ReadonlyArray<number>) => void;
  values: number[];
}

export const RangeSlider: React.FC<RangeSliderProps> = ({
  dataTestId,
  disabled = false,
  disabledMessage,
  domain,
  onChange,
  onUpdate,
  values,
}) => (
  <Slider
    mode={1}
    step={1}
    className={classnames('range-slider', {
      'range-slider--disabled': disabled,
    })}
    data-test-id={dataTestId}
    domain={domain}
    onChange={onChange}
    onUpdate={onUpdate}
    disabled={disabled}
    values={values}
  >
    <Rail>{({ getRailProps }) => <SliderRail getRailProps={getRailProps} />}</Rail>
    <Handles>
      {({ activeHandleID, handles, getHandleProps }) => (
        <div className="slider-handles">
          {handles.map((handle) => (
            <RangeSliderHandle
              dataTestId={dataTestId}
              disabled={disabled}
              disabledMessage={disabledMessage}
              domain={domain}
              getHandleProps={getHandleProps}
              handle={handle}
              isActive={handle.id === activeHandleID}
              key={handle.id}
            />
          ))}
        </div>
      )}
    </Handles>
    <Tracks right={false}>
      {({ tracks, getTrackProps }) => (
        <div className="range-slider__tracks">
          {tracks.map(({ id, source, target }) => (
            <RangeSliderTrack key={id} source={source} target={target} getTrackProps={getTrackProps} />
          ))}
        </div>
      )}
    </Tracks>
  </Slider>
);
